import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // 👈 import this
import ProductCard from "../components/ProductCard";
//import allProducts from "../assets/data/products.json";
import allProducts from "../assets/data/processedProducts";
import imageMap from "../assets/data/imageMap";

const ProductsTapsPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialSeries = queryParams.get("series") || "All";
  const initialType = queryParams.get("type") || "All";
  const [showModelDropdown, setShowModelDropdown] = useState(false);

  const taps = allProducts.filter((item) => item.Category === "Taps");

  const [selectedType, setSelectedType] = useState(initialType);
  const [selectedSeries, setSelectedSeries] = useState(initialSeries);
  const [showSeriesDropdown, setShowSeriesDropdown] = useState(false);

  useEffect(() => {
    setSelectedSeries(initialSeries);
    setSelectedType(initialType);
  }, [initialSeries, initialType]);

  const availableTypes = [
    "All",
    ...new Set(
      taps
        .filter((tap) => selectedSeries === "All" || tap.Series === selectedSeries)
        .map((tap) => tap.Type)
    ),
  ];

  const availableSeries = [
    "All",
    ...new Set(
      taps
        .filter((tap) => selectedType === "All" || tap.Type === selectedType)
        .map((tap) => tap.Series)
    ),
  ];

  const filteredTaps = taps.filter((tap) => {
    const typeMatch = selectedType === "All" || tap.Type === selectedType;
    const seriesMatch = selectedSeries === "All" || tap.Series === selectedSeries;
    return typeMatch && seriesMatch;
  });

const seriesImages = {};

taps
  .filter((tap) => tap.Item.endsWith("-01"))
  .forEach((tap) => {
    if (!seriesImages[tap.Series]) {
      seriesImages[tap.Series] = imageMap[tap.Image] || null;
    }
  });

  console.log("Series Images:", seriesImages);

  return (
    <div className="container mx-auto p-4 pt-20">
      <h1 className="text-2xl font-bold mb-4">Taps & Faucets</h1>

      {/* Filters */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        {/* Series Dropdown */}
        <div className="relative w-full md:w-1/2">
          <label className="block mb-1 text-sm font-medium text-gray-700">Series</label>
          <div className="relative">
            <button
              onClick={() => setShowSeriesDropdown(!showSeriesDropdown)}
              className="w-full flex justify-between items-center border border-gray-300 rounded px-4 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <div className="flex justify-between items-center w-full">
                <span>{selectedSeries}</span>
              </div>
              <span className="ml-2">▼</span>
            </button>
            {showSeriesDropdown && (
              <div className="absolute left-0 right-0 mt-1 bg-white border rounded shadow z-10 max-h-64 overflow-y-auto">
                {availableSeries.map((s) => (
                  <div
                    key={s}
                    className="flex justify-between items-center p-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => {
                      setSelectedSeries(s);
                      setShowSeriesDropdown(false);
                    }}
                  >
                    <span className="text-sm text-gray-800">{s}</span>
                    {seriesImages[s] && (
                      <img src={seriesImages[s]} alt={s} className="w-12 h-12 object-contain rounded" />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Model Dropdown */}
{/* Model Dropdown */}
<div className="relative w-full md:w-1/2">
  <label className="block mb-1 text-sm font-medium text-gray-700">Model</label>
  <div className="relative">
    <button
      onClick={() => setShowModelDropdown(prev => !prev)}
      className="w-full flex justify-between items-center border border-gray-300 rounded px-4 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <span>{selectedType}</span>
      <span className="ml-2">▼</span>
    </button>
    {showModelDropdown && (
      <div className="absolute left-0 right-0 mt-1 bg-white border rounded shadow z-10 max-h-64 overflow-y-auto">
        {availableTypes.map((t) => (
          <div
            key={t}
            className="p-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-800"
            onClick={() => {
              setSelectedType(t);
              setShowModelDropdown(false);
            }}
          >
            {t}
          </div>
        ))}
      </div>
    )}
  </div>
</div>

      </div>

      {/* Product Grid */}
      {filteredTaps.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filteredTaps.map((tap) => (
            <ProductCard key={tap.ID} product={tap} />
          ))}
        </div>
      ) : (
        <div className="text-center text-gray-600 mt-10">
          No products found for the selected filters. Please try adjusting your selection.
        </div>
      )}
    </div>
  );
};

export default ProductsTapsPage;
